export type HotelsTableLoadingInput = {
  isLoading: boolean;
  isPlaceholderData: boolean;
  isSuccess: boolean;
  search: string | undefined;
  settledSearch: string | undefined;
};

export const resolveHotelsTableLoading = ({
  isLoading,
  isPlaceholderData,
  search,
  settledSearch,
}: HotelsTableLoadingInput): boolean =>
  isLoading || (isPlaceholderData && search !== settledSearch);

export const resolveSettledSearch = ({
  isPlaceholderData,
  isSuccess,
  search,
  settledSearch,
}: HotelsTableLoadingInput): string | undefined =>
  isSuccess && !isPlaceholderData ? search : settledSearch;
